/* eslint-disable no-unused-vars */
import React, { useContext, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Box, LinearProgress, Stack } from '@mui/material';
import { DriveFileRenameOutlineOutlined } from '@mui/icons-material';
import moment from 'moment';
import AlertContext from '../../../../Context/AlertContext';
import Elements from '../../../Elements';
import { getCourierDetail } from '../../../../Redux/Models/courier';
import Images from '../../../../Configs/images';
import { IconRequests } from '../../../../Assets/Icons';
import ROUTES from '../../../../Configs/routes';

export default function Component({
  data, classes, error, message, selectedCourier: courier, isLoading,
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { courierId } = useParams();

  const { openAlert } = useContext(AlertContext);

  useEffect(() => {
    dispatch(getCourierDetail(courierId));
  }, [courierId]);

  useEffect(() => {
    if (error) {
      openAlert({
        message: `Something went wrong. ${message}`,
        severity: 'error',
      });
    }
  }, [error]);

  return (
    <Elements.AdminPageBase navigate={navigate}>
      <div className={classes.root}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Box fontSize={20}>
            <strong>Courier</strong>
          </Box>
          {/* <Box
            display="flex"
            alignItems="center"
            gap={1}
            py={1}
            px={2}
            bgcolor="#FDFDFD"
            borderRadius="10px"
            border="1px solid #E5E5E5"
            className="link"
            fontSize={14}
          >
            <img src={Images.Download} alt="download" height="20" width="20" />
            Download Order Report
          </Box> */}
        </Box>

        {isLoading && <LinearProgress color="inherit" sx={{ mt: 2 }} />}

        <Box p={3} bgcolor="#FDFDFD" borderRadius="10px" mt={4}>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Box fontSize={18} fontWeight="700">Profile Information</Box>
            <Box display="flex" gap={1} alignItems="center" fontSize={12} className="primary-green link" onClick={() => navigate(`${ROUTES.couriers()}/update/${courierId}`)}>
              <DriveFileRenameOutlineOutlined fontSize="small" />
              Edit Information
            </Box>
          </Box>

          <Box fontWeight="700" fontSize={12} mt={3}>Profile</Box>

          <Box display="flex" alignItems="flex-start" mt={2} gap={2} flexWrap="wrap">
            <Box flex={1.5} display="flex" justifyContent="center">
              <Box display="inline-flex" flexDirection="column" alignItems="center">
                <img src={courier.personal_data?.profile_picture} alt="courier" width="64" height="64" className="circle cover" />
                <Box className="mute s-12" mt={0.5}>
                  {courier.courier_info?.id?.slice(0, 5)}
                  ...
                </Box>
                <Box fontSize={18} fontWeight="700" mt={0.5}>{courier.personal_data?.name}</Box>
                <Box display="flex" gap={0.5} alignItems="center" color="#ABB1BB" fontSize={12} mt={0.5}>
                  <IconRequests iconcolor="#ABB1BB" width="10" height="10" sx={{ fontSize: 12 }} />
                  {courier.request?.length || 0}
                  {' '}
                  order
                </Box>
              </Box>
            </Box>
            <Box flex={1}>
              <Stack direction="column" spacing={1}>
                <Box>
                  <Box className="mute" fontSize={12}>Join Date</Box>
                  <Box fontSize={14} fontWeight="700" mt={0.5}>{moment(courier.courier_info?.created_at).format('DD MMM YYYY')}</Box>
                </Box>
                <Box>
                  <Box className="mute" fontSize={12}>Gender</Box>
                  <Box fontSize={14} fontWeight="700" mt={0.5}>{courier.personal_data?.gender}</Box>
                </Box>
                <Box>
                  <Box className="mute" fontSize={12}>Marital Status</Box>
                  <Box fontSize={14} fontWeight="700" mt={0.5}>{courier.personal_data?.marital_status}</Box>
                </Box>
              </Stack>
            </Box>
            <Box flex={2}>
              <Stack direction="column" spacing={1}>
                <Box>
                  <Box className="mute" fontSize={12}>Phone Number</Box>
                  <Box fontSize={14} fontWeight="700" mt={0.5}>{courier.personal_data?.phone_number}</Box>
                </Box>
                <Box>
                  <Box className="mute" fontSize={12}>Email</Box>
                  <Box fontSize={14} fontWeight="700" mt={0.5}>{courier.personal_data?.email}</Box>
                </Box>
                <Box>
                  <Box className="mute" fontSize={12}>Address</Box>
                  <Box fontSize={14} fontWeight="700" mt={0.5}>{courier.personal_data?.address}</Box>
                </Box>
              </Stack>
            </Box>
            <Box flex={1.5}>
              <Stack direction="column" spacing={1}>
                <Box>
                  <Box className="mute" fontSize={12}>Nationality ID </Box>
                  <Box fontSize={14} fontWeight="700" mt={0.5} display="flex" gap={1} alignItems="center">
                    {courier.document_data?.id_card}
                    <a href={courier.document_data?.id_document} target="_blank" className="primary-green s-12 italic weight-600" rel="noreferrer">See ID</a>
                  </Box>
                </Box>
                <Box>
                  <Box className="mute" fontSize={12}>Driver License ID</Box>
                  <Box fontSize={14} fontWeight="700" mt={0.5} display="flex" gap={1} alignItems="center">
                    {courier.document_data?.driver_license_number}
                    <a href={courier.document_data?.driver_license_document} target="_blank" className="primary-green s-12 italic weight-600" rel="noreferrer">See ID</a>
                  </Box>
                </Box>
              </Stack>
            </Box>
          </Box>
        </Box>

        <Box p={3} bgcolor="#FDFDFD" borderRadius="10px" mt={3}>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Box fontSize={18} fontWeight="700">Work Order History</Box>
          </Box>

          {courier.request && courier.request?.length
            ? (
              <table style={{ marginTop: 16 }}>
                <thead>
                  <tr style={{ background: '#2E3C40' }}>
                    <td className="white">Order ID</td>
                    <td className="white">Status</td>
                    <td className="white">Service</td>
                    <td className="white">Order Date</td>
                    <td className="white">Customer</td>
                    <td className="white">Destination</td>
                  </tr>
                </thead>
                <tbody>
                  {courier.request?.map((req) => (
                    <tr key={req.id}>
                      <td>
                        <Link to={`${req.type === 'Request Out' ? ROUTES.requestOut() : ROUTES.requestIn()}/${req.id}`} className="primary-green">
                          {req.id?.slice(0, 5)}
                          ...
                        </Link>
                      </td>
                      <td>{req.status}</td>
                      <td>{req.type}</td>
                      <td>{req.pickup_date ? moment(req.pickup_date).format('DD MMM YYYY, HH.mm') : '-'}</td>
                      <td>{req.customer_name || '-'}</td>
                      <td>{req.address || '-'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <div className="s-16 mt-5 center">
                <img src={Images.Sure} alt="No data" />
                <div className="weight-700 mt-4">No Available History Right Now!</div>
                <div className="mt-2">Courier work history will appear in here</div>
              </div>
            )}
        </Box>
      </div>
    </Elements.AdminPageBase>
  );
}
